// Helpers to format WhatsApp phone numbers coming from the admin settings.
// Accepts numbers like "+55 (31) 98298-7356", "5531982987356", "31982987356".

export function formatWhatsappLink(phone, message = '') {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return '';
  const withCountry = digits.length <= 11 ? `55${digits}` : digits;
  const q = message ? `?text=${encodeURIComponent(message)}` : '';
  return `https://wa.me/${withCountry}${q}`;
}

export function formatWhatsappDisplay(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return '';
  // Strip leading 55 country code for display when present
  const local = digits.startsWith('55') && digits.length > 11 ? digits.slice(2) : digits;
  if (local.length === 11) return `(${local.slice(0, 2)}) ${local.slice(2, 7)}-${local.slice(7)}`;
  if (local.length === 10) return `(${local.slice(0, 2)}) ${local.slice(2, 6)}-${local.slice(6)}`;
  return phone; // fall back to raw
}
